import { objectFilter } from './object-filter.js';
const UTMPattern = /^utm_/i;
export const isUTMParam = (param) => UTMPattern.test(param);
export const filterObjectUTMParams = objectFilter((val, key) => isUTMParam(key) && !!val && val !== 'undefined');
//# sourceMappingURL=utm.js.map